import { j as s } from "../../../jsx-runtime-B3iL8JI7.js";
import { textLinkStyles as p } from "./TextLink.styles.js";
import a from "../Icon/Icon.js";
import j from "../../../tailwindConfig/bclTwMerge.js";
const S = ({
  children: o,
  className: l = "",
  disabled: e,
  href: n,
  iconLeft: t,
  iconRight: r,
  target: i,
  ...x
}) => {
  const {
    base: d,
    default: m,
    disabled: c
  } = p;
  return /* @__PURE__ */ s.jsxs(
    "a",
    {
      href: n,
      className: j(
        d,
        e ? c : m,
        l
      ),
      target: i,
      "aria-disabled": e,
      tabIndex: e ? -1 : void 0,
      ...x,
      children: [
        t && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(a, { icon: t }) }),
        o,
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(a, { icon: r }) })
      ]
    }
  );
};
export {
  S as default
};
